import script from "./CreateEditEmailConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEditEmailConfig.vue?vue&type=script&lang=ts&setup=true"

import "./CreateEditEmailConfig.vue?vue&type=style&index=0&id=37340f31&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37340f31"]])

export default __exports__